import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../constants';
import type { IZonesState } from '../types';

export const fetchAllZones = createAppAsyncThunk(`${SLICE_NAMESPACE}/fetchAllZones`, async () =>
  apiService.masterEntities.getZoneList(),
);

export const fetchAllZonesReducer: TSliceExtraReducer<IZonesState> = builder =>
  builder
    .addCase(fetchAllZones.pending, state => {
      state.isLoading = true;
    })
    .addCase(fetchAllZones.rejected, state => {
      state.isLoading = false;
      state.zones = [];
    })
    .addCase(fetchAllZones.fulfilled, (state, action) => {
      state.zones = action.payload;
      state.isLoading = false;
    });
